/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Subscription_Cancel_Effective_DateInputs */

const fr_subscription_cancel_effective_date = /** @type {(inputs: Subscription_Cancel_Effective_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Votre abonnement restera actif jusqu'au ${i?.date}, en raison de votre période d'engagement, puis ne sera plus renouvelé.`)
};

/**

* @param {Subscription_Cancel_Effective_DateInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const subscription_cancel_effective_date = /** @type {((inputs: Subscription_Cancel_Effective_DateInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Cancel_Effective_DateInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_subscription_cancel_effective_date(inputs)
});